import Vue from 'vue/dist/vue.esm.js';

Vue.component('ajax-pagination', {
    template: `#ajax-pagination`,
    delimiters: ['[[', ']]'],
    props: {
        currentPage: {
            required: true,
            type: Number,
            default: 1
        },
        totalItems: {
            required: true,
            type: Number,
        },
        currentPageItems: {
            required: true,
            type: Number,
        },
        itemsPerPage: {
            required: true,
            type: Number,
        },
    },
    data() {
        return {
            allAjaxResults: '',
            request: false,
            totalShownItems: this.currentPageItems
        }
    },
    methods: {
        getMoreResults() {
            let _self = this;
            let targetUrl = (window.location.href);
            let isSecTypeView = $('.sec-type').hasClass('active');
            if(this.request){
                this.request.abort();
            }
            let url = new URL(targetUrl);
            url.searchParams.set('page', _self.currentPage + 1);
            url.searchParams.set('sec-type', isSecTypeView);
            history.replaceState(history.state, '', url.href);

            this.request = $.ajax({
                data: null,
                url: url.href,
                method: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                success: function (result) {
                    _self.currentPage++
                    _self.currentPageItems = ($(result).first('.products-list').children().children().length);
                    _self.totalShownItems += _self.currentPageItems;
                    _self.allAjaxResults += result;
                },
            });
        }
    },

    computed: {
        nextPageResults() {
            return Math.min(this.itemsPerPage, this.currentPageItems, (this.totalItems - this.totalShownItems));
        }
    }
});